import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { Consumer, ConsumerData } from 'src/shared/features/consumers/schemas/consumer'

/**
 * Creates a new consumer with the provided data
 * @param consumerData Object containing firstName, lastName, primaryEmail, and phoneNumber
 */
const createReferralClient = (consumerData: ConsumerData) => {
  return postRequest<Consumer>('/consumers/referral-client', consumerData)
}

/**
 * Hook for creating a new consumer
 * @returns Mutation function that takes consumer data (firstName, lastName, primaryEmail, phoneNumber)
 */
export const useCreateReferralClient = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (referralClientData: ConsumerData) => createReferralClient(referralClientData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.consumers.all.queryKey })
    },
  })
}

// Export the hook with the name expected in client-info.tsx
export const useCreateConsumer = useCreateReferralClient
